import "chart.js/auto";
import { Line } from "react-chartjs-2";
import styled from "styled-components";

const LineWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  position: relative;
  box-shadow: ${({ theme }) => theme.shadow.shad_100};
  background-color: rgb(252, 252, 252);
  padding-top: 3rem;

  .title-wrapper {
    width: 100%;
    justify-content: space-between;
    position: absolute;
    top: 0.5rem;
    left: 0;
    padding: 0.5rem 2rem 0.5rem 1rem;

    .legends {
      gap: 1rem;
    }
    .legend {
      gap: 0.5rem;

      .dot {
        background-color: #fb896b;
        width: 0.9rem;
        height: 0.9rem;
        border-radius: 50%;
      }

      .second {
        background-color: #6956e5;
      }
      h3 {
        font-weight: 400;
        font-size: 1rem;
        color: ${({ theme }) => theme.text.muted_200};
      }
    }
  }
`;

export interface ILineChartProps {
  chartData: any;
  options: any;
  title: string;
  first: string;
  second: string;
  height?: number;
}

export function LineChart({
  chartData,
  options,
  title,
  first,
  second,
  height,
}: ILineChartProps) {
  return (
    <LineWrapper>
      <Line height={height} options={options} data={chartData} />
      <div className="title-wrapper flex-row">
        <h2 className="dash-title">{title}</h2>
        <div className="legends flex-row">
          <div className="legend flex-row">
            <div className="dot first"></div>
            <h3>{first}</h3>
          </div>
          <div className="legend flex-row">
            <div className="dot second"></div>
            <h3>{second}</h3>
          </div>
        </div>
      </div>
    </LineWrapper>
  );
}
